const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL;

type ContactPayload = {
  company: string;
  email: string;
  message: string;
  name: string;
};

type ContactResponse = {
  message?: string;
};

export async function sendPublicContactMessage(
  payload: ContactPayload,
): Promise<ContactResponse> {
  const response = await fetch(new URL("/public/contact", API_BASE_URL), {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const text = await response.text();
  let data: unknown;

  try {
    data = text ? JSON.parse(text) : undefined;
  } catch {
    data = undefined;
  }

  const record =
    data && typeof data === "object" ? (data as Record<string, unknown>) : null;

  if (!response.ok) {
    const message =
      typeof record?.message === "string"
        ? record.message
        : "Could not send your message. Please try again.";
    throw new Error(message);
  }

  const unwrapped =
    record?.success === true && record.data && typeof record.data === "object"
      ? (record.data as ContactResponse)
      : (record as ContactResponse | null);

  return unwrapped ?? {};
}
